export default {"src":"/evde-internet/_next/static/media/saving.c265f709.svg","height":48,"width":48};